// axios
import axios from 'axios'
import store from './store';
import router from './router';
import { notifyApiError } from './services/apiNotice';

const baseURL = process.env.VUE_APP_API_URL;

// export default axios.create({
//   baseURL: baseURL,
//   // You can add your headers here
//   headers: {
//     Authorization: store.state.token,
//   }
// });

const instance = axios.create({
  baseURL: baseURL,
});

instance.interceptors.request.use((config) => {
  const token = store.state.token;

  if (token) {
    config.headers.Authorization = token;
  }

  return config;
});

instance.interceptors.response.use(
  (response) => {
    if (response.data && (response.data.code === '9999' || response.data.code === 9999)) {
      store.dispatch('SETLOGOUT').then(() => {
        router.push({ path: '/signin' });
      });
      return new Promise(() => {});
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch('SETLOGOUT').then(() => {
        router.push({ path: '/signin' });
      });
      return new Promise(() => {});
    }
    // 2026-09-02: 통신 실패를 눈에 보이게 한다.
    //   전수조사에서 `.catch()` 없는 호출이 SHOP 18곳 확인됐다 —
    //   실패하면 아무 반응이 없어 사용자는 '버튼이 안 먹는다'로 본다.
    //   던지기는 그대로 던져서 기존 .catch() 는 계속 동작한다.
    notifyApiError(error);
    return Promise.reject(error);
  }
);

export default instance;